const imageMap = {
    4: require("@/assets/images/inplay-cricket-icon.webp"),
    1: require("@/assets/images/inplay-football-icon.webp"),
    2: require("@/assets/images/inplay-tennis-icon.webp"),
    27454571: require("@/assets/images/esports.webp"),
    2152880: require("@/assets/images/gaelic-games.webp"),
    998917: require("@/assets/images/volleyball.webp"),
    7524: require("@/assets/images/ice-hockey.webp"),
    7522: require("@/assets/images/basketball.webp"),
    7511: require("@/assets/images/baseball.webp"),
    6423: require("@/assets/images/american-football.webp"),
    6422: require("@/assets/images/snooker.webp"),
    27454572: require("@/assets/images/kabaddi.webp"),
    27454574: require("@/assets/images/table-tennis.webp"),
    27454581: require("@/assets/images/9ball-pool.svg"),
    468328: require("@/assets/images/handball.webp"),
    61420: require("@/assets/images/australian-rules.webp"),
    26420387: require("@/assets/images/mixed-martial-arts.webp"),
};

export function getSportImage(sportId) {
    return imageMap[sportId] || require("@/assets/images/default-sport.png");
}
